import { addDays, startOfToday, parseISO, formatISO } from 'date-fns';
import * as React from 'react';

import { getButtonLabel } from './utils';
import { LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED } from '../../../../../../shared/common/hooks/useUxFbPoll/constants';
import {
  getLocalStorageFiltersWereAppliedTwoTimes,
  setLocalStorageFiltersApplied,
} from '../../../../../../shared/common/hooks/useUxFbPoll/localStorageUtils';
import { getDateRangeValue } from '../../../../../JsonQuery';
import { Dates } from '../../../components/filters/Dates';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const DatesContainer: React.FC = () => {
  const { jsonQuery, onChange, onApply } = useFiltersContext();

  const range = getDateRangeValue('dates')(jsonQuery);

  const [isOpen, setIsOpen] = React.useState(false);

  const today = startOfToday();
  const minDate = today;
  const maxDate = addDays(today, 365);
  const fromValue = range?.gte ? parseISO(range.gte) : null;
  const toValue = range?.lt ? parseISO(range.lt) : null;

  const buttonLabel = getButtonLabel(fromValue, toValue);

  const isLocalStorageFiltersWereAppliedTwoTimes = getLocalStorageFiltersWereAppliedTwoTimes(
    LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED,
  );

  const handleButtonClick = React.useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const handleClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleDatesChange = React.useCallback(
    (from: Date | undefined, to: Date | undefined) => {
      let fromValue = from;
      let toValue = to;

      if (fromValue && !toValue) {
        toValue = addDays(fromValue, 1);
      }
      if (toValue && !fromValue) {
        fromValue = addDays(toValue, -1);
      }
      if (fromValue && toValue && fromValue >= toValue) {
        toValue = addDays(fromValue, 1);
      }

      if (fromValue && toValue) {
        const gte = formatISO(fromValue, { representation: 'date' });
        const lte = formatISO(toValue, { representation: 'date' });

        onChange({ action: 'setDates', arguments: [gte, lte] });
        onApply();
        handleClose();
      }

      //Если фильтр был применен 2 раза, сохраняем значеине в LocalStorage
      if (!isLocalStorageFiltersWereAppliedTwoTimes) {
        setLocalStorageFiltersApplied(LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED);
      }
    },
    [onApply, onChange, isLocalStorageFiltersWereAppliedTwoTimes, setLocalStorageFiltersApplied],
  );

  return (
    <Dates
      isOpen={isOpen}
      buttonLabel={buttonLabel}
      minDate={minDate}
      maxDate={maxDate}
      fromValue={fromValue}
      toValue={toValue}
      onButtonClick={handleButtonClick}
      onDatesChange={handleDatesChange}
      onClose={handleClose}
    />
  );
};
